import React, { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { removeToken, getToken } from "../../Services/LocalStorageService";
import { motion, AnimatePresence } from "framer-motion";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import BadgeIcon from "@mui/icons-material/Badge";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentsIcon from "@mui/icons-material/Payments";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ListAltIcon from "@mui/icons-material/ListAlt";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardHome from "../Dashboard/DashboardHome";
import { fetchPermission } from "../../Services/Services";

export default function AdminDashboard({ setIsAuthenticated }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { access_token, user_type } = getToken();

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [reportOpen, setReportOpen] = useState(false);
  const [activePath, setActivePath] = useState("");
  const [allowedPages, setAllowedPages] = useState([]);

  useEffect(() => {
    if (location.pathname.includes("/reports-view")) {
      setActivePath("/reports-view");
    } else {
      setActivePath(location.pathname);
    }
  }, [location.pathname]);

  console.log(location.pathname)

  useEffect(() => {
  const userType = localStorage.getItem("user_type");
  const userId = localStorage.getItem("user_id");

  if (userType === "Staff" && userId) {
    fetchPermission(userId).then((res) => {
      console.log(res);
      if (res && res.label) {
        setAllowedPages(res.label);
      }
    });
  }
}, []);

  // redirect base /admin to dashboard
  useEffect(() => {
    if (access_token && location.pathname === "/admin") {
      navigate("dashboard", { replace: true });
    }
  }, [access_token, location.pathname, navigate]);

  const handleLogout = () => {
    removeToken();
    setIsAuthenticated(false);
    localStorage.clear();
    navigate("/");
  };

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  /* Sidebar items */
  const sidebarItems = [
    { to: "dashboard", icon: <DashboardIcon />, label: "Dashboard" },
    { to: "assign", icon: <DashboardIcon />, label: "Assign" },
    { to: "addclients", icon: <PersonAddIcon />, label: "Client" },
    { to: "lifter-user", icon: <GroupAddIcon />, label: "Lifter" },
    { to: "staff-user", icon: <BadgeIcon />, label: "Staff" },
    { to: "entry_do_no", icon: <NoteAddIcon />, label: "Do No" },
    {
      to: "lifter-assign-view",
      icon: <AssignmentIndIcon />,
      label: "Lifter DO",
    },
    {
      to: "lifter-dispatch-view",
      icon: <LocalShippingIcon />,
      label: "Dispatch",
    },
    { to: "freight-pay", icon: <PaymentsIcon />, label: "Freight Pay" },
    {
      to: "lifter-payment-view",
      icon: <AccountBalanceWalletIcon />,
      label: "Lifter Pay",
    },
    {
      to: "party-payment-view",
      icon: <AccountBalanceWalletIcon />,
      label: "Party Pay",
    },
    { to: "Order_form", icon: <AddShoppingCartIcon />, label: "Today Order" },
    { to: "all_order", icon: <ListAltIcon />, label: "All Orders" },
    { to: "bill-view", icon: <VisibilityIcon />, label: "Bill View" },
  ];

  /* Reports menu */
  const reportItems = [
    { value: "do_status", label: "Do Status" },
    { value: "do_pending_for_bill", label: "Do Pending For Bill" },
    { value: "do_bill_register", label: "Do Bill Register" },
    { value: "sale_do", label: "Sale Do List" },
    { value: "leps_do", label: "Leps Do List" },
    { value: "DispacthStatus", label: "Freight Status By Do" },
    { value: "MonthlyReport", label: "Monthly Freight Report" },
    { value: "YearlyReport", label: "Yearly Freight Report" },
    { value: "CustomFrieghtReport", label: "Custom Freight Report" },
    { value: "FreightPaymetRegister", label: "Freight Payment Register" },
    { value: "PendingFreightPaymet", label: "Pending Freight Payment" },
    { value: "TdsFreightList", label: "Tds Freight List" },
    { value: "FreightNotApplicableList", label: "Freight Not Applicable List" },
  ];

  /* Role & Permission Based Filtering */
let sidebarFiltered = [];
let reportsFiltered = [];

if (user_type === "Admin") {
  sidebarFiltered = sidebarItems;
  reportsFiltered = reportItems;
} else if (user_type === "Staff") {
  sidebarFiltered = sidebarItems.filter((i) => allowedPages.includes(i.to));
  reportsFiltered = reportItems.filter((r) => allowedPages.includes(r.value));
} else if (user_type === "Lifter") {
  sidebarFiltered = sidebarItems.filter((i) =>
    ["dashboard", "lifter-assign-view", "lifter-dispatch-view", "lifter-payment-view"].includes(i.to)
  );
  reportsFiltered = reportItems.filter((r) =>
    ["do_status"].includes(r.value)
  );
}


  /* JSX */
  return (
    <div style={{ height: "100vh", fontFamily: "Poppins, sans-serif" }}>
      {/* Header */}
      <motion.div
        initial={{ y: -60 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.4 }}
        style={{
          height: 65,
          background: "#1e293b",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 25px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={toggleSidebar}
        >
          {sidebarOpen ? (
            <MenuIcon
              style={{ fontSize: 28, marginRight: 10, color: "#fff" }}
            />
          ) : (
            <CloseIcon
              style={{ fontSize: 28, marginRight: 10, color: "#fff" }}
            />
          )}
          {user_type.charAt(0).toUpperCase() + user_type.slice(1)} Dashboard
        </div>

        <div style={{ fontSize: 18, fontWeight: 900 }}>
          {localStorage.getItem("com_name") === "priyanshi"
            ? "PRIYANSHI COAL FEADER PVT. LTD."
            : "KAMAL TRADING COMPANY"}
        </div>

        {access_token && (
          <motion.div
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              background: "linear-gradient(135deg, #4141ff, #2b32ff)",
              padding: "5px 10px",
              borderRadius: 50,
              color: "#fff",
              fontWeight: 600,
              fontSize: 12,
              letterSpacing: "0.5px",
              textTransform: "uppercase",
            }}
            onClick={handleLogout}
          >
            <LogoutIcon style={{ fontSize: 20, marginRight: 8 }} />
            Logout
          </motion.div>
        )}
      </motion.div>

      {/* Sidebar */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            key="sidebar"
            initial={{ x: -250 }}
            animate={{ x: 0 }}
            exit={{ x: -250 }}
            transition={{ duration: 0.4 }}
            style={{
              position: "fixed",
              top: 65,
              left: 0,
              bottom: 0,
              width: 240,
              background: "#1e293b",
              padding: "20px 15px",
              overflowY: "auto",
              color: "#fff",
            }}
          >
            {/* MAIN LINKS */}
            {sidebarFiltered.map((item, idx) => {
              const isActive = location.pathname.endsWith(item.to);
              return (
                <Link
                  key={idx}
                  to={item.to}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 10px",
                    marginBottom: 8,
                    textDecoration: "none",
                    borderRadius: 8,
                    color: "#fff",
                    background: isActive ? "#ff8c42" : "transparent", // orange active
                    fontWeight: isActive ? 600 : 400,
                    transition: "background 0.3s",
                  }}
                >
                  {item.icon}
                  <span style={{ marginLeft: 12 }}>{item.label}</span>
                </Link>
              );
            })}

            {/* REPORTS */}
            <div
              onClick={() => setReportOpen(!reportOpen)}
              style={{
                marginTop: 10,
                padding: "10px",
                borderRadius: 10,
                background: "#334155",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "#fff",
                fontWeight: 500,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <AssessmentIcon />
                <span style={{ marginLeft: 12 }}>Reports</span>
              </div>
              {reportOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
            </div>

            {reportOpen && (
              <div style={{ paddingLeft: 30 }}>
                {reportsFiltered.map((r, idx) => {
                  const isActive = location.search.includes(
                    `report=${r.value}`
                  );
                  return (
                    <div
                      key={idx}
                      onClick={() =>
                        navigate(`/reports-view?report=${r.value}`)
                      }
                      style={{
                        padding: "6px 0",
                        cursor: "pointer",
                        color: isActive ? "#ff8c42" : "#fff",
                        fontWeight: isActive ? 600 : 400,
                        transition: "0.3s",
                      }}
                    >
                      {r.label}
                    </div>
                  );
                })}
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>

      {/* Content Area */}
      <div
        style={{
          position: "fixed",
          top: "65px",
          left: sidebarOpen ? "240px" : "0px",
          right: 0,
          fontSize: "0.8rem",
          bottom: 0,
          padding: "10px",
          transition: "left 0.3s ease",
        }}
      >
        {location.pathname.includes("dashboard") ? (
          <DashboardHome />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
}
